import { testMsg } from "../../test-apis";
import { isTestCompany } from "../../utils/auth";
import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 기간 내 휴일 목록
export const getHolidaysCalendarList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/holidays/calendar/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 사내 휴일 기준 목록
export const getHolidaysList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/holidays/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 사내 휴일 기준 등록
export const createHolidays = (body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .post("/holidays", body)
      .then((res) => {
        toast.success('사내 휴일 기준이 등록되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 사내 휴일 기준 상세
export const getHolidays = (holidayIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/holidays/${holidayIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 사내 휴일 기준 수정
export const modifyHolidays = (holidayIdx, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .put(`/holidays/${holidayIdx}`, body)
      .then((res) => {
        toast.success('사내 휴일 기준이 수정되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 사내 휴일 기준 삭제
export const deleteHolidays = (holidayIdx) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .delete(`/holidays/${holidayIdx}`)
      .then((res) => {
        toast.success('사내 휴일 기준이 삭제되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
